import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "ASSET", {
  DELETED: "Assets deleted succesfully",
  CREATED: "Asset created succesfully",
});
